<template>
    <v-card class="pa-4">
        <v-card-title class="text-h4">
            {{ month_name }}
        </v-card-title>
        <template v-if="plan_name">
            <div class="text-h4 text-center">
                {{ plan_name }}
            </div>
            <v-list v-if="isPaidPlan">
                <v-list-item
                    v-for="(send_count, index) in send_count_list"
                    :key="index"
                >
                    <v-list-item-title class="overflow-visible">
                        {{ getSignatureMethodText(index) }}
                    </v-list-item-title>
                    <v-list-item-title class="text-right" v-if="index != 'total'">
                        {{ send_count }}件
                    </v-list-item-title>
                    <v-list-item-title class="text-right" v-else>
                        合計 {{ send_count }}件
                    </v-list-item-title>
                </v-list-item>
            </v-list>
            <v-list v-else>
                <v-list-item>
                    <v-list-item-title>
                        送信件数
                    </v-list-item-title>
                    <v-list-item-title class="text-right">
                        {{ send_count_list.total }}/5件
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </template>
    </v-card>
</template>

<script>
    import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
    export default {
        props: [
            'month_name',
            'plan_name', 
            'plan_identifier', 
            'send_count_list', 
        ],
        mixins:[
            signatureMethodMixin
        ],
        created : function() {
            this.isPaidPlan = this.plan_identifier !== 'free' ? true : false;
        },
    };
</script>

<style scoped lang="scss">
    .v-card {
        background-color: #F4FEFB;
        height: 324px;
    }
    
    .v-list {
        background-color: #F4FEFB;
    }
</style>